import { TournamentScope } from '@app/graphql'

export const TournamentScopeNameMap = new Map<TournamentScope, string>([
  [ TournamentScope.Favorite, 'common.favourite' ],
  [ TournamentScope.Popular, 'common.popular' ],
  [ TournamentScope.Regular, 'common.all' ],
])
